<template>
    <div>
        <rkm-modal
            :buttons="['cancel']"
            extraLarge
            ref="RkmModal"
            title="Histórico de uso de medicamentos"
        >

            <rkm-alert show info v-if="paciente">
                <strong>Paciente:</strong>

                {{ paciente.nome }}

                <strong v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                    ({{ paciente.nomeSocial }})
                </strong> -

                <strong>Idade:</strong>
                        <template v-if="paciente.idade">
                            {{ paciente.anos }} anos,
                            {{ paciente.meses }} meses e
                            {{ paciente.dias }} dias
                        </template>
                        <template v-else>
                            -
                        </template> -
                    <strong>Prontuário: </strong>{{ paciente.prontuario }}
            </rkm-alert>

            <rkm-table
                :fields="fields.tables.medicamentos"
                :items="items"
                sort-by="data"
            />
       </rkm-modal>
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import sexo from '@/enums/cadastro/cidadao/sexo'

// Mixins.
import { repository, error, object, data } from '@/mixins'

export default {
    computed: {
        fields() {
            return {
                tables: {
                    medicamentos: [
                        { key: 'data', label: 'Data', class: 'col-min', sortable: true },
                        { key: 'usoMedicamento', label: 'Medicamento', sortable: true },
                    ],
                },
            }
        },
    },
    created() {

        this.repositories = {
            agendamento: this.getConectaSusRepository('exameLaboratorial.agendamentoExame'),
        }
    },
    data: () => ({
        items: [],
        enums: {
            preferenciaNome,
            sexo,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(pacienteId) {

            this.setLoading()

            this.repositories.agendamento.getHistoricoMedicamento(pacienteId)
                .then(({ data }) => {

                    this.items = data
                })
            .catch(this.handleError)
            .finally(() => this.unsetLoading(this.$nextTick(() => this.$refs.RkmModal.show())))
        },
    },
    mixins: [ repository, error, object, data ],
    props: {
        paciente: { type: Object, required: true},
    },
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>